import { VueNodeViewRenderer } from '@tiptap/vue-3'
import FileWrapper from '~/tiptap/files/FileWrapper.vue'
import { FileSchema } from '~/tiptap/files/file-schema'

export const File = FileSchema.extend({
  addNodeView() {
    return VueNodeViewRenderer(FileWrapper)
  },
})
